import React from 'react';
import WhyNonLithiumSection from '../components/WhyNonLithiumSection';

const WhyNonLithiumPage = () => {
  return (
    <div className="pt-20">
      <section className="py-16 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Why <span className="text-emerald-400">Non-Lithium</span>?
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Discover the advantages of moving beyond lithium-ion technology.
          </p>
        </div>
      </section>
      <WhyNonLithiumSection />
    </div>
  );
};

export default WhyNonLithiumPage;
